namespace TabAurous {
    export interface AddressRequest extends Serenity.ListRequest {
        StateIds?: number[];
        States?: string[];
        Cities?: string[];
        Countries?: string[];
        State?: string;
        City?: string;
        Country?: string;
    }
}
